import { Translate } from "@/app/application/Translate";
import {
	DashboardCardConfig,
	DashboardCardGroupConfig,
	TrainingType,
} from "@/features/training/pages/Dashboard/Types";

/**
 * Default cards to render on the TrainingDashboard.
 */
export const cardsConfig: DashboardCardConfig[] = [
	{
		type: "course",
		data: "upcoming",
		name: (
			<Translate String="Training.Dashboard.CardConfig.Training">
				Training
			</Translate>
		),
	},
	{
		type: "course",
		data: "overdue",
		name: (
			<Translate String="Training.Dashboard.CardConfig.Training">
				Training
			</Translate>
		),
	},
	{
		type: "archive",
		trainingType: TrainingType.Courses,
		name: (
			<Translate String="Training.Dashboard.CardConfig.Training">
				Training
			</Translate>
		),
	},
	{
		type: "drill",
		data: "upcoming",
		name: (
			<Translate String="Training.Dashboard.CardConfig.Drill">Drill</Translate>
		),
	},
	{
		type: "drill",
		data: "overdue",
		name: (
			<Translate String="Training.Dashboard.CardConfig.Drill">Drill</Translate>
		),
	},
	{
		type: "archive",
		trainingType: TrainingType.Exercises,
		name: (
			<Translate String="Training.Dashboard.CardConfig.Drill">Drill</Translate>
		),
	},
];

export const dashboardCardGroups: DashboardCardGroupConfig[] = [
	{
		key: "training-row",
		title: (
			<Translate String="Training.Dashboard.Groups.Training">
				Training
			</Translate>
		),
		description: (
			<Translate String="Training.Dashboard.Groups.TrainingDescription">
				Upcoming, overdue, and archived training sessions
			</Translate>
		),
		cards: cardsConfig.slice(0, 3),
	},
	{
		key: "drill-row",
		title: (
			<Translate String="Training.Dashboard.Groups.Drills">
				Drill sessions
			</Translate>
		),
		description: (
			<Translate String="Training.Dashboard.Groups.DrillsDescription">
				Upcoming, overdue, and archived drill sessions
			</Translate>
		),
		cards: cardsConfig.slice(3, 6),
	},
];
